export default function referralForm() {
    const referralPage = $(".ReferralPage");
    const ethnicItems = $(".referral-ethnic");
    const otherEthnicWrapper = $("#OtherEthnicWrapper");
    const emailField = $("#ReferralForm_ReferralForm_Email");
    const confirmEmailField = $("#ReferralForm_ReferralForm_ConfirmEmail");

    if (referralPage.length > 0) {

        // $(".optionset[aria-required='true']").each(function () {
        //     const $group = $(this);
        //     const $radios = $group.find("input[type='radio']");

        //     if ($radios.length) {
        //         $radios.first().attr("required", "true");
        //     }
        // });

        $("#ReferralForm_ReferralForm.needs-validation").on("submit", function (e) {
            checkEmailsMatch();
            let formValid = $(this)[0].checkValidity();
            if (formValid === false) {
                e.preventDefault();
                $(this).addClass("was-validated");
            }
        });

        confirmEmailField.siblings('.invalid-feedback').each(function () {
            $(this).data('default-text', $(this).text());
        });

        emailField.add(confirmEmailField).on("input blur", checkEmailsMatch);

        initialiseItems()

        ethnicItems.on('change',function (){
            let showOther = false;
            ethnicItems.each(function(){
                if($(this).val() === 'Other' && $(this)[0].checked){
                    showOther = true;
                }
            });
            if(showOther){
                otherEthnicWrapper.removeClass('d-none')
            } else {
                otherEthnicWrapper.addClass('d-none')
            }

            initialiseItems()
        });
    }

    function initialiseItems() {
        console.log('initialising')
        let itemsAreChecked = checkItemsChecked()
        console.log(itemsAreChecked)
        setRequired(itemsAreChecked)
    }

    function checkItemsChecked(){
        let itemsChecked = false
        ethnicItems.each(function(){
            if($(this)[0].checked){
                itemsChecked = true;
            }
        })
        return itemsChecked;
    }

    function setRequired($checked){
        ethnicItems.each(function(){
            if(!$checked){
                $(this).attr('required','required');
            } else {
                $(this).removeAttr('required');
            }
        })
    }

    function checkEmailsMatch(){
        if (!confirmEmailField.length) {
            return;
        }

        const confirmEmailInput = confirmEmailField[0];
        const feedback = confirmEmailField.siblings('.invalid-feedback');
        const mismatch = confirmEmailInput.value !== '' && confirmEmailInput.value !== emailField.val();

        confirmEmailInput.setCustomValidity(mismatch ? 'Email and Confirm Email must match' : '');
        feedback.text(mismatch ? 'Email and Confirm Email must match' : feedback.data('default-text'));
    }

}
